import { render, staticRenderFns } from "./SelectCustomValue.vue?vue&type=template&id=5b382873&scoped=true&"
import script from "./SelectCustomValue.vue?vue&type=script&lang=js&"
export * from "./SelectCustomValue.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomValue.vue?vue&type=style&index=0&id=5b382873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b382873",
  null
  
)

export default component.exports